






import AbpBase from "@/lib/abpbase";
import ECharts from "vue-echarts";
import { Component, Prop, Watch } from "vue-property-decorator";
import { GetSummaryChartList } from "@/api/pdQualityControlManage/pdSummary";
@Component({
  components: {
    ECharts
  }
})
export default class PdSummaryColumnar extends AbpBase {
  @Prop() data: any;
  loading: boolean = false;
  @Watch("data", { immediate: true, deep: true })
  async onDataChanged() {
    this.loading = true;
    this.options.legend.data = [];
    this.options.xAxis.data = [];
    this.options.series = [];
    if (this.data.time == undefined || this.data.chartType == undefined) return;
    let res = await GetSummaryChartList(this.data);
    let chartData = res.objects;
    let legendData: any = [chartData.title];
    let xAxis: any = [];
    let series: any = [
      {
        name: chartData.title,
        type: "line",
        stack: "总量",
        data: []
      }
    ];

    chartData.summaryChartData.forEach((item: any) => {
      xAxis.push(this.formatDate(item.name));
      series[0].data.push(item.value);
    });
    this.options.legend.data = legendData;
    this.options.xAxis.data = xAxis;
    this.options.series = series;
    this.loading = false;
  }

  options: any = {
    tooltip: {
      trigger: "axis"
    },
    // 数据标题
    legend: {
      data: []
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true
    },
    toolbox: {
      feature: {
        saveAsImage: {}
      }
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: [] // X轴坐标点
    },
    yAxis: {
      type: "value"
    },
    series: []
  };
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdQualityControlManage/pdSummary/columnar.vue